import styles from "./Label.module.scss";

const OneLineLabel = ({ text }) => {
  return <div className={styles.oneLineLabel}>{text}</div>;
};

export default OneLineLabel;
